import React from 'react';

// 部分需求需要根据语言变化对应显示不同
const useGetLang = () => {
  const [lang, setLang] = React.useState('en');

  const sessionLang = sessionStorage.getItem('oper_lang') || 'en';

  React.useEffect(() => {
    setLang(sessionLang);
  }, [sessionLang]);

  return lang;
};

export default useGetLang;
